import { Injectable, NgZone } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { Router } from '@angular/router';
import { AppService } from './app.service';



@Injectable({
  providedIn: 'root',
})
export class JWTTokenService {
  jwtToken: string | null | undefined;
  decodedToken: { [key: string]: any } | null = null;
  private tokenCheckInterval: any;

 constructor(private router: Router,private appService: AppService) {}

  decodeToken(): void {
    if (this.jwtToken) {
      try {
        this.decodedToken = jwtDecode(this.jwtToken);
      } catch (error) {
        console.error('Error decoding token:', error);
        this.decodedToken = null;
        this.router.navigate(['/login']);
      }
    }
  }

  getUser(): string | null {
    this.jwtToken = this.getToken();
    this.decodeToken();
    return this.decodedToken ? this.decodedToken['email'] : null;
  }

  getExpiryTime(): number | null {
    this.decodeToken();
    return this.decodedToken ? Number(this.decodedToken['exp']) : null;
  }

  isTokenExpired(): boolean {
    const expiryTime = this.getExpiryTime();
    return expiryTime ? expiryTime * 1000 < Date.now() : true;
  }

  public startTokenExpirationCheck(): void {
    this.clearTokenExpirationCheck();

    this.tokenCheckInterval = setInterval(async () => {
      const expiryTime = this.getExpiryTime();

      if (!expiryTime || Date.now() / 1000 > expiryTime) {
        this.appService.addWarnMessage('Session expired. Please log in again.');
        console.log('Calling handleTokenInvalidation from JWT...');
        Promise.resolve(this.handleTokenInvalidation())
          .then(() => {
            console.log('handleTokenInvalidation finished from JWT...');
            return Promise.resolve(this.clearTokenExpirationCheck());
          })
          .then(() => {
            console.log('signOut finished from JWT...');
          });

        this.appService.remove('xdbc.lastUrl');
      }
    }, 1000);
  }

  public clearTokenExpirationCheck(): void {
    if (this.tokenCheckInterval) {
      clearInterval(this.tokenCheckInterval);
      this.tokenCheckInterval = null;
    }
  }

  public getToken(): string {
    const cookies = document.cookie.split('; ').find(row => row.startsWith('session_token='));
    return cookies ? cookies.split('=')[1] : '';
  }

  public handleTokenInvalidation(): void {
    this.jwtToken = undefined;
    this.decodedToken = null;
    // this.appService.clearLocalStorage();
    this.router.navigate(['/login']);
  }

}